<template>
  <div>
    <a v-on:click.prevent="showModal = true" class="delete" href="#">{{ $t("plans.deleteStar.delete") }}</a>
      <Modal class="alert" v-if="showModal" v-bind:modalTitle="$t('plans.deleteStar.modal.header')" @close="showModal = false">
        <p class="modal-text" v-html="$t('plans.deleteStar.modal.text', {name: projectName})"></p>
        <a v-on:click.prevent="deleteStar" class="button" href="#">{{ $t("plans.deleteStar.modal.button") }}</a>
      </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue'

import { userService } from '@/services/user.service'

export default {
  props: ['projectId', 'projectName'],
  name: 'DeleteStar',
  components: {
    Modal
  },
  data: function () {
    return {
      showModal: false
    }
  },
  methods: {
    deleteStar: function () {
      userService.deleteStar(this.projectId).then(() => {
        this.showModal = false
        this.$router.go(0)
      }).catch((err) => {
        console.error('Something went wrong: ', err)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
a.delete {
  display: block;
  width: 16px;
  height: 20px;
  margin-left: 30px;
  background: url('../../assets/icons/trash-can.png') no-repeat;
  text-indent: -9999px;
  white-space: nowrap;
}
.modal-text {
  font-weight: bold;
}
</style>
